module.exports = __webpack_public_path__ + "img/imagen-derecha.edc39588.png";